'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreeTrialSignupV3 = exports.mapStateToProps = exports.mapDispatchToProps = exports.FreeTrialSignupV3Unwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactRedux = require('react-redux');

var _homepage = require('redux/modules/features/homepage');

var _bound = require('redux/saga/entities/bound');

var _msas = require('redux/saga/selectors/msas');

var _promotions = require('constants/promotions');

var _Sagas = require('decorators/Sagas');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _optimizely = require('helpers/optimizely');

var _CallToAction = require('components/CallToAction');

var _LocationSelector = require('components/CmsPage/modules/LocationSelector/LocationSelector');

var _FreeTrialSignup = require('./FreeTrialSignup.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreeTrialSignupV3Unwrapped = exports.FreeTrialSignupV3Unwrapped = function (_Component) {
  (0, _inherits3.default)(FreeTrialSignupV3Unwrapped, _Component);

  function FreeTrialSignupV3Unwrapped() {
    var _ref;

    (0, _classCallCheck3.default)(this, FreeTrialSignupV3Unwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = FreeTrialSignupV3Unwrapped.__proto__ || (0, _getPrototypeOf2.default)(FreeTrialSignupV3Unwrapped)).call.apply(_ref, [this].concat(args)));

    _this.handleCta = _this.handleCta.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FreeTrialSignupV3Unwrapped, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var msa = this.props.msa;


      if (nextProps.msa !== msa) {
        this.props.loadPromotion(nextProps.msa);
      }
    }
  }, {
    key: 'handleCta',
    value: function handleCta() {
      (0, _optimizely.trackOptimizelyEvent)('successful_plan_selection');
    }
  }, {
    key: 'renderSalesPitch',
    value: function renderSalesPitch() {
      return _react2.default.createElement(
        'section',
        { className: 'sales-pitch' },
        _react2.default.createElement(
          'h2',
          { className: 'sales-pitch__title' },
          'A month of workouts, for free.'
        ),
        _react2.default.createElement(
          'p',
          { className: 'sales-pitch__description' },
          'ClassPass gives you access to the world\u2019s top studios and gyms, so you can try cycling, yoga, boxing, and more \u2014 wherever you are.'
        ),
        _react2.default.createElement(
          'picture',
          { className: 'sales-pitch__image' },
          _react2.default.createElement('source', {
            srcSet: require('./static/img/calendar.png'),
            media: '(min-width: 480px) and (max-width: 767px)'
          }),
          _react2.default.createElement('source', {
            srcSet: require('./static/img/calendar-mobile.png'),
            media: '(min-width: 768px) and (max-width: 899px)'
          }),
          _react2.default.createElement('source', {
            srcSet: require('./static/img/calendar.png'),
            media: '(min-width: 900px)'
          }),
          _react2.default.createElement('img', { src: require('./static/img/calendar-mobile.png'), alt: 'calendar' })
        )
      );
    }
  }, {
    key: 'renderPlanCard',
    value: function renderPlanCard() {
      var classEstimateMax = this.props.classEstimateMax;

      return _react2.default.createElement(
        'section',
        { className: 'plan-card' },
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'p',
            { className: 'plan-card__tag' },
            'FREE MONTH!'
          ),
          _react2.default.createElement(
            'h2',
            { className: 'plan-card__callout' },
            '$0'
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'plan-card__details' },
          classEstimateMax && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_reactInlinesvg2.default, { src: require('./static/img/muscle.svg') }),
            _react2.default.createElement(
              'span',
              { className: 'plan-card__details__detail' },
              'Take up to ',
              classEstimateMax,
              ' classes in your first month!'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_reactInlinesvg2.default, { src: require('./static/img/unlocked.svg') }),
            _react2.default.createElement(
              'span',
              { className: 'plan-card__details__detail' },
              'You\u2019re never locked in. Cancel anytime.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'plan-card__cta' },
          _react2.default.createElement(
            _CallToAction.CallToAction,
            {
              action: _CallToAction.ACTIONS.OFFER_CHECKOUT,
              color: 'primary_solid',
              extraClass: 'bt--lg bt--width-md',
              onClick: this.handleCta,
              promotionAlias: this.props.promotionAlias
            },
            'Start your trial'
          )
        )
      );
    }
  }, {
    key: 'renderAvailableLocationFinder',
    value: function renderAvailableLocationFinder() {
      return _react2.default.createElement(
        'div',
        { className: 'available-location-finder' },
        _react2.default.createElement(_LocationSelector.LocationSelector, null)
      );
    }
  }, {
    key: 'renderDisclaimer',
    value: function renderDisclaimer() {
      var recurringPlanPrice = this.props.recurringPlanPrice;

      return _react2.default.createElement(
        'p',
        { className: 'free-trial-signup-v3__disclaimer' },
        'After your free trial, you\u2019ll auto-enroll in our $',
        recurringPlanPrice,
        '/month plan. Change or cancel any time during your trial to not be charged.'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { className: 'free-trial-signup-v3' },
        _react2.default.createElement(
          'div',
          { className: 'free-trial-signup-v3__section-1' },
          this.renderPlanCard(),
          this.renderAvailableLocationFinder(),
          this.renderDisclaimer()
        ),
        _react2.default.createElement(
          'div',
          { className: 'free-trial-signup-v3__section-2' },
          this.renderSalesPitch()
        )
      );
    }
  }]);
  return FreeTrialSignupV3Unwrapped;
}(_react.Component);

FreeTrialSignupV3Unwrapped.propTypes = {
  classEstimateMax: _propTypes2.default.number.isRequired,
  loadPromotion: _propTypes2.default.func.isRequired,
  msa: _propTypes2.default.object,
  promotionAlias: _propTypes2.default.string.isRequired,
  recurringPlanPrice: _propTypes2.default.number.isRequired
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadPromotion: _FreeTrialSignup.loadFreeTrialPromotion
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var msa = (0, _msas.msaByIdentifier)(_bound.msas.data(state), (0, _homepage.selectMsaId)(state)) || {};
  var promotionAlias = _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
  var promotionKey = _bound.promotionByAlias.defaultKey(null, promotionAlias, msa.id);
  var promotion = _bound.promotionByAlias.data(state, promotionKey) || {};

  return {
    classEstimateMax: (0, _deep.deepExtract)('offers.0.initial_plan.max_class_estimate', promotion),
    msa: msa,
    promotionAlias: promotionAlias,
    recurringPlanPrice: (0, _deep.deepExtract)('offers.0.recurring_plan.price', promotion)
  };
};

var FreeTrialSignupV3 = exports.FreeTrialSignupV3 = (0, _decorator.decorateWith)(_TrackDwell2.default, (0, _Sagas.withSagas)({ load: _FreeTrialSignup.loadSaga, watch: _FreeTrialSignup.watchSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(FreeTrialSignupV3Unwrapped);